import { Controller } from "@hotwired/stimulus"

// Reloads the turbo-frame it's in after a moment, for as long as the frame's
// content keeps this controller (a photo search still working).
export default class extends Controller {
  static values = { every: { type: Number, default: 1500 } }

  connect() {
    this.timer = setTimeout(() => {
      const frame = this.element.closest("turbo-frame")
      if (!frame) return
      if (frame.src) frame.reload()
      else frame.src = window.location.href
    }, this.everyValue)
  }

  disconnect() { clearTimeout(this.timer) }
}
